import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { toast } from '@/components/ui/Toast'

export interface CommentRow {
  id: string
  user_id: string
  text: string
  is_from_biz: boolean
  likes_count: number
  created_at: string
  author: { username: string; avatar_url: string | null } | null
}

export function useComments(postId: string, limit = 50) {
  return useQuery({
    queryKey: ['comments', postId, limit],
    queryFn: () =>
      api.get<{ data: CommentRow[]; count: number }>(
        `/api/comments?postId=${postId}&limit=${limit}`
      ),
    enabled: !!postId,
    staleTime: 1000 * 15,
  })
}

export function useAddComment(postId: string) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (text: string) => api.post('/api/comments', { postId, text }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comments', postId] }),
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useDeleteComment(postId: string) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (commentId: string) => api.delete(`/api/comments/${commentId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comments', postId] }),
    onError: (err: Error) => toast.error(err.message),
  })
}
